"use strict";

export default {
  getParams: () => {
    const url = window.location.href,
      urlParams = new URLSearchParams(url);

    let params = "";

    if (url.search("utm_medium=emailmkt") > -1) {
      if (url.search("id_origem_vivo") < 1) {
        params += "id_origem_vivo=b2c-movel_clm_banner_email&";
      } else {
        params += `id_origem_vivo=${urlParams.get("id_origem_vivo")}&`;
      }

      if (url.search("origin") < 1) {
        params += "origin=b2c-movel_clm_banner_email&";
      } else {
        params += `origin=${urlParams.get("origin")}&`;
      }
    }

    if (url.search("utm_medium=sms") > -1) {
      if (url.search("id_origem_vivo") < 1) {
        params += "id_origem_vivo=b2c-movel_clm_hyperlink_sms&";
      } else {
        params += `id_origem_vivo=${urlParams.get("id_origem_vivo")}&`;
      }

      if (url.search("origin") < 1) {
        params += "origin=b2c-movel_clm_hyperlink_sms&";
      } else {
        params += `origin=${urlParams.get("origin")}&`;
      }
    }

    // console.log('origin=', urlParams.get('origin'))
    // console.log('id_origem_vivo=', urlParams.get('id_origem_vivo'))

    if (!params) {
      const origin = urlParams.get("origin");
      params += origin ? `&origin=${origin}&id_origem_vivo=${origin}` : "";
    }

    return params;
  },

  getInternParams: () => {
    const url = window.location.search.substring(1),
      urlParams = new URLSearchParams(url);

    let params = "";

    if (urlParams.get("plano")) {
      params += `&plano=${urlParams.get("plano")}`;
    }

    if (urlParams.get("doubleredes")) {
      params += `&doubleredes=${urlParams.get("doubleredes")}`;
    }

    if (urlParams.get("cliente-especial-meuvivo")) {
      params += `&cliente-especial-meuvivo`;
    }

    if (urlParams.get("movimento")) {
      params += `&movimento=${urlParams.get("movimento")}`;
    }

    if (urlParams.get("acao")) {
      params += `&acao=${urlParams.get("acao")}`;
    }

    return params;
  },
};
